export default {
  meta: {
    title: '审批流程配置',
    url: '/system/approvalflow', // 埋点用，记录所属模块
  },
};
